<p>支払い情報入力</p>
<button id="ssn-test-payment--input" class="testButton" (click)="paymentInputTest1()">支払い情報入力画面へ</button>
